export class UnverifiedAccountError extends Error {}
